"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlidePanel = void 0;
const react_1 = __importStar(require("react"));
const utils_1 = require("../utils");
const SlidePanel = ({ side = "left", isOpen, onClose, children, className, overlayClass, }) => {
    const panelRef = (0, react_1.useRef)(null);
    const lastFocusedElement = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (isOpen) {
            lastFocusedElement.current = document.activeElement;
            document.body.style.overflow = "hidden";
            setTimeout(() => {
                panelRef.current?.focus();
            }, 100);
        }
        else {
            document.body.style.overflow = "";
            lastFocusedElement.current?.focus();
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);
    (0, react_1.useEffect)(() => {
        if (!isOpen)
            return;
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose?.();
            }
            if (event.key === "Tab") {
                const focusableElements = panelRef.current?.querySelectorAll("a, button, input, textarea, select, [tabindex]:not([tabindex='-1'])");
                if (!focusableElements || focusableElements.length === 0)
                    return;
                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];
                if (event.shiftKey && document.activeElement === firstElement) {
                    lastElement.focus();
                    event.preventDefault();
                }
                else if (!event.shiftKey && document.activeElement === lastElement) {
                    firstElement.focus();
                    event.preventDefault();
                }
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [isOpen, onClose]);
    (0, react_1.useEffect)(() => {
        if (!panelRef.current)
            return;
        // Set tabIndex=-1 on all focusable elements when closed
        const focusableElements = panelRef.current.querySelectorAll("a, button, input, textarea, select, [tabindex]:not([tabindex='-1'])");
        focusableElements.forEach((el) => {
            el.tabIndex = isOpen ? 0 : -1;
        });
    }, [isOpen]);
    const handleOverlayClick = () => {
        onClose?.();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isOpen && (react_1.default.createElement("div", { onClick: handleOverlayClick, className: (0, utils_1.cn)("w-full h-full bg-brandBlack opacity-75 fixed left-0 top-0 z-[99999]", overlayClass) })),
        react_1.default.createElement("div", { ref: panelRef, role: "dialog", "aria-modal": "true", tabIndex: -1, className: (0, utils_1.cn)("fixed bg-brandWhite shadow-lg transition-transform duration-300 ease-in-out z-[99999] outline-none", side === "left" && "top-0 bottom-0 left-0 w-72", side === "right" && "top-0 bottom-0 right-0 w-72", side === "top" && "left-0 right-0 top-0 h-72", side === "bottom" && "left-0 right-0 bottom-0 h-72", isOpen
                ? "transform translate-x-0 translate-y-0"
                : side === "left"
                    ? "transform -translate-x-full"
                    : side === "right"
                        ? "transform translate-x-full"
                        : side === "top"
                            ? "transform -translate-y-[110%]"
                            : "transform translate-y-full", !isOpen && "pointer-events-none", className), onClick: (e) => e.stopPropagation() }, children)));
};
exports.SlidePanel = SlidePanel;
